var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckedCheckbox = function SvgCheckedCheckbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "#4F52C3",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 3,
    fill: "inherit"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m4 8.172 2.69 2.67M6.688 10.84l5.38-5.34",
    stroke: "#fff",
    strokeWidth: 1.75,
    strokeLinecap: "round"
  })));
};
export default SvgCheckedCheckbox;